import { type IntlShape } from 'react-intl'

import { type UserOrderResponseWithFlagsSubOrdersInner } from '@redteclab/api/clients/bully'

import { directContactFormSubjectPolicyGetByTranslatedSubject } from '../../direct-contact'
import {
  subOrderStatusAccessorGetAfterSalesSelfServiceAvailability,
  subOrderStatusAccessorGetDocumentsSelfServiceAvailability,
  subOrderStatusAccessorGetOrderModificationSelfServiceAvailability,
  subOrderStatusAccessorGetTrackingSelfServiceAvailability,
} from '../../order'

type SelfServiceAvailability = 'disabled' | 'enabled' | 'hidden'

type GetAvailability = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner,
) => SelfServiceAvailability

export const directContactFormAccessorGetAvailabilityBySubject = (
  intl: IntlShape,
  subject: string,
): GetAvailability | null => {
  const { policy } = directContactFormSubjectPolicyGetByTranslatedSubject({
    intl,
    subject,
  })

  switch (policy.selfServiceAvailabilityStrategy) {
    case 'afterSales': {
      return (subOrder) =>
        subOrderStatusAccessorGetAfterSalesSelfServiceAvailability(
          subOrder,
          false,
        )
    }
    case 'documents': {
      return subOrderStatusAccessorGetDocumentsSelfServiceAvailability
    }
    case 'orderModification': {
      return subOrderStatusAccessorGetOrderModificationSelfServiceAvailability
    }
    case 'tracking': {
      return subOrderStatusAccessorGetTrackingSelfServiceAvailability
    }
    default: {
      return null
    }
  }
}
